export default {
  methods: {
    AxiosHelperShowResponce (axiosRequest, successCallback) {
      axiosRequest
        .then(response => {
          this.$store.dispatch('showSuccessWindow')
          this.$store.commit('load', false)
          successCallback(response)
        })
        .catch(error => {
          console.log('error!!!!!1')
          this.$store.dispatch('showErrorMessage', error)
          this.$store.commit('load', false)
        })
    }
  }
}